class PredictiveSearch extends SearchForm {
  constructor() {
    (super(),
      (this.cachedResults = {}),
      (this.predictiveSearchResults = this.querySelector(
        "[data-predictive-search]",
      )),
      (this.allPredictiveSearchInstances =
        document.querySelectorAll("predictive-search")),
      (this.isOpen = !1),
      (this.abortController = new AbortController()),
      (this.searchTerm = ""),
      (this.body = document.querySelector("body")),
      (this.header = document.querySelector(".shopify-section-header")),
      (this.headerBottom = document.querySelector(".header__bottom")),
      (this.promoModal = document.querySelector(".search__modal")),
      (this.collectionList = document.querySelector(
        ".template-404__collections",
      )),
      (this.headerInput = document.querySelector(
        ".header__search .search__input",
      )),
      (this.onFormSubmitBound = this.onFormSubmit.bind(this)),
      (this.onFocusBound = this.onFocus.bind(this)),
      (this.onFocusOutBound = this.onFocusOut.bind(this)),
      (this.onKeyupBound = this.onKeyup.bind(this)),
      (this.onDocumentPointerDownBound = this.onDocumentPointerDown.bind(this)),
      this.calcHeight(),
      this.setupEventListeners());
  }
  calcHeight() {
    ((this.results = document.querySelector(
      ".predictive-search__result-group",
    )),
      (this.resultsTabs = document.querySelector(
        ".predictive-search__result-tabs",
      )),
      this.results &&
        this.results.style.setProperty(
          "--search-height",
          parseInt(this.resultsTabs.getBoundingClientRect().bottom) + "px",
        ));
  }
  setupEventListeners() {
    (this.input.form.addEventListener("submit", this.onFormSubmitBound),
      this.input.addEventListener("focus", this.onFocusBound),
      this.addEventListener("focusout", this.onFocusOutBound),
      this.addEventListener("keyup", this.onKeyupBound),
      document.addEventListener(
        "pointerdown",
        this.onDocumentPointerDownBound,
      ));
  }
  disconnectedCallback() {
    (document.removeEventListener(
      "pointerdown",
      this.onDocumentPointerDownBound,
    ),
      this.input?.form?.removeEventListener("submit", this.onFormSubmitBound),
      this.input?.removeEventListener("focus", this.onFocusBound),
      this.removeEventListener("focusout", this.onFocusOutBound),
      this.removeEventListener("keyup", this.onKeyupBound));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    var e = this.getQuery();
    ((this.searchTerm && e.startsWith(this.searchTerm)) ||
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove(),
      this.updateSearchForTerm(this.searchTerm, e),
      (this.searchTerm = e),
      this.searchTerm.length
        ? (this.getSearchResults(this.searchTerm),
          this.getQuery().length
            ? this.hidePromoBlock()
            : this.showPromoBlock())
        : this.close(!0));
  }
  onFormSubmit(e) {
    (this.getQuery().length &&
      !this.querySelector('[aria-selected="true"] a') &&
      !e.submitter.classList.contains("card__link")) ||
      e.preventDefault();
  }
  onFormReset(e) {
    (super.onFormReset(e),
      super.shouldResetForm() &&
        ((this.searchTerm = ""),
        this.abortController.abort(),
        (this.abortController = new AbortController()),
        this.closeResults(!0)));
  }
  onFocus() {
    var e = this.getQuery();
    (this.classList.contains("search-modal__form") &&
      (this.headerBottom &&
        this.headerBottom.classList.add("header__bottom--visible"),
      this.promoModal &&
        this.promoModal.classList.remove("search__modal--hidden"),
      this.collectionList) &&
      this.collectionList.classList.remove("hidden"),
      e.length &&
        (this.searchTerm !== e
          ? this.onChange()
          : "true" === this.getAttribute("results")
            ? (this.open(),
              this.promoModal &&
                this.promoModal.classList.add("search__modal--hidden"),
              this.collectionList &&
                this.collectionList.classList.add("hidden"))
            : this.getSearchResults(this.searchTerm)));
  }
  onFocusOut() {
    (this.classList.contains("search-modal__form") &&
      this.headerBottom &&
      this.headerBottom.classList.remove("header__bottom--visible"),
      setTimeout(() => {
        this.closeIfOutside();
      }));
  }
  onDocumentPointerDown(e) {
    this.isOpen &&
      e.target instanceof Node &&
      !this.contains(e.target) &&
      this.close(!this.classList.contains("search-modal__form"));
  }
  closeIfOutside() {
    var e = document.activeElement;
    (e && e instanceof Node && this.contains(e)) ||
      this.close(!this.classList.contains("search-modal__form"));
  }
  onBlur() {
    this.headerInput.blur();
  }
  onKeyup(e) {
    switch (
      (this.getQuery().length || this.close(!0), e.preventDefault(), e.code)
    ) {
      case "Enter":
        (e.preventDefault(), this.selectOption());
        break;
      case "Escape":
        (this.close(!0),
          this.closeResults(clearSearchTerm),
          this.getQuery().length
            ? this.hidePromoBlock()
            : this.showPromoBlock());
    }
  }
  updateSearchForTerm(e, t) {
    var s = this.querySelector("[data-predictive-search-search-for-text]"),
      i = s?.innerText;
    if (i) {
      if (1 < i.matchAll(new RegExp(e, "g")).length) return;
      i = i.replace(e, t);
      s.innerText = i;
    }
    this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock();
  }
  selectOption() {
    var e = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]',
    );
    e && e.click();
  }
  getSearchResults(e) {
    let s = e.replace(" ", "-").toLowerCase();
    (this.setLiveRegionLoadingState(),
      this.cachedResults[s]
        ? (this.renderSearchResults(this.cachedResults[s]),
          this.clickSearchTabs(),
          this.calcHeight())
        : (this.promoModal &&
            this.classList.contains("search-modal__form") &&
            this.promoModal.classList.add("search__modal--hidden"),
          this.collectionList && this.collectionList.classList.add("hidden"),
          fetch(
            `${routes.predictive_search_url}?q=${encodeURIComponent(e)}&section_id=predictive-search`,
            { signal: this.abortController.signal },
          )
            .then((e) => {
              if (e.ok) return e.text();
              throw ((e = new Error(e.status)), this.close(), e);
            })
            .then((e) => {
              let t = new DOMParser()
                .parseFromString(e, "text/html")
                .querySelector("#shopify-section-predictive-search").innerHTML;
              (this.allPredictiveSearchInstances.forEach((e) => {
                e.cachedResults[s] = t;
              }),
                this.renderSearchResults(t),
                this.clickSearchTabs(),
                this.calcHeight());
              try {
                colorSwatches();
              } catch (e) {}
            })
            .catch((e) => {
              if (20 !== e?.code) throw (this.close(), e);
            }),
          this.getQuery().length
            ? this.hidePromoBlock()
            : this.showPromoBlock()));
  }
  setLiveRegionLoadingState() {
    ((this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status")),
      (this.loadingText =
        this.loadingText || this.getAttribute("data-loading-text")),
      this.setLiveRegionText(this.loadingText),
      this.setAttribute("loading", !0));
  }
  setLiveRegionText(e) {
    (this.statusElement.setAttribute("aria-hidden", "false"),
      (this.statusElement.textContent = e),
      setTimeout(() => {
        this.statusElement.setAttribute("aria-hidden", "true");
      }, 1e3));
  }
  renderSearchResults(e) {
    ((this.predictiveSearchResults.innerHTML = e),
      this.setAttribute("results", !0),
      this.setLiveRegionResults(),
      this.open(),
      this.promoModal &&
        this.classList.contains("search-modal__form") &&
        this.promoModal.classList.add("search__modal--hidden"),
      this.collectionList && this.collectionList.classList.add("hidden"));
  }
  clickSearchTabs() {
    let i = this.querySelectorAll(".predictive-search__results-list");
    0 != i.length &&
      (i[0].classList.add("active"),
      this.querySelector(".predictive-search__result-tab").classList.add(
        "active",
      ),
      this.querySelectorAll(".predictive-search__result-tab").forEach((s) => {
        s.addEventListener("click", (e) => {
          e.preventDefault();
          let t = s.dataset.typeTarget;
          (this.querySelectorAll(".predictive-search__result-tab").forEach(
            (e) => {
              e.classList.remove("active");
            },
          ),
            s.classList.add("active"),
            i.forEach((e) => {
              e.dataset.type == t
                ? e.classList.add("active")
                : e.classList.remove("active");
            }));
        });
      }));
  }
  hidePromoBlock() {
    this.classList.contains("search-modal__form") &&
      (this.promoModal &&
        this.promoModal.classList.add("search__modal--hidden"),
      this.collectionList) &&
      this.collectionList.classList.add("hidden");
  }
  showPromoBlock() {
    this.classList.contains("search-modal__form") &&
      (this.promoModal &&
        this.promoModal.classList.remove("search__modal--hidden"),
      this.collectionList) &&
      this.collectionList.classList.remove("hidden");
  }
  setLiveRegionResults() {
    (this.removeAttribute("loading"),
      this.setLiveRegionText(
        this.querySelector("[data-predictive-search-live-region-count-value]")
          .textContent,
      ));
  }
  open() {
    (this.setAttribute("open", !0),
      this.input.setAttribute("aria-expanded", !0),
      (this.isOpen = !0),
      this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock());
  }
  close(e = !1) {
    (this.closeResults(e), (this.isOpen = !1));
  }
  closeResults(e = !1) {
    e && ((this.input.value = ""), this.removeAttribute("results"));
    e = this.querySelector('[aria-selected="true"]');
    (e && e.setAttribute("aria-selected", !1),
      this.input.setAttribute("aria-activedescendant", ""),
      this.removeAttribute("loading"),
      this.removeAttribute("open"),
      this.input.setAttribute("aria-expanded", !1),
      this.predictiveSearchResults.removeAttribute("style"),
      this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock());
  }
}
customElements.define("predictive-search", PredictiveSearch);
